export function Footer() {
  return (
    <footer className="footer">
      <span>Expense Analyzer by Ciminaghi (MCT &amp; MVP)</span>
      <span>Built on Microsoft Azure</span>
      <a href="https://www.linkedin.com/in/emanueleciminaghi/" target="_blank" rel="noreferrer">
        LinkedIn
      </a>
      <span>Copyright {new Date().getFullYear()}</span>
    </footer>
  );
}
